import { render, staticRenderFns } from "./RecordBoard.vue?vue&type=template&id=46a175f0&scoped=true&"
import script from "./RecordBoard.vue?vue&type=script&lang=js&"
export * from "./RecordBoard.vue?vue&type=script&lang=js&"
import style0 from "./RecordBoard.vue?vue&type=style&index=0&id=46a175f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a175f0",
  null
  
)

export default component.exports